import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { user } from 'store/reducers/user'
import useFetchAllBanners from './useFetchAllBanners'
import postalCodeToKanton from 'utils/postalCodeToKantons.json'
import { LOCATION_NOT_SPECIFIED } from 'utils'
import {
  STUDENT_DASHBOARD_BANNER_TYPE,
  bannerTypeMapping,
} from 'components/Admin/Banner/constants'

/**
 * Custom hook to fetch banners for the Student Dashboard.
 * Automatically handles user location based on role, login status, and postal code.
 * 
 * @returns {Object} { banners, loading, error, refetch }
 */
const useStudentDashboardBanner = () => {
  const { isLoggedIn, postalCode, role } = useSelector(user)
  const userLocationFromCookies = localStorage.getItem('location')

  const filterParams = useMemo(
    () => ({
      type: bannerTypeMapping[STUDENT_DASHBOARD_BANNER_TYPE],
      location:
        role === 'Teacher'
          ? userLocationFromCookies !== LOCATION_NOT_SPECIFIED
            ? userLocationFromCookies
            : undefined
          : isLoggedIn
          ? postalCodeToKanton[postalCode]?.kanton
          : userLocationFromCookies !== LOCATION_NOT_SPECIFIED
          ? userLocationFromCookies
          : undefined,
      isStarted: true,
      isExpired: false,
    }),
    [role, isLoggedIn, postalCode, userLocationFromCookies]
  )

  const {
    banners,
    loading,
    error,
    refetch,
  } = useFetchAllBanners(filterParams)

  return { banners, loading, error, refetch }
}

export default useStudentDashboardBanner
